<template>
  <div class="star-rating">
    <div class="star-rating__row flex--row-center-center">
      <Star
        :colour="colour"
        :style="colourVar"
        :class="{
          'star-rating--filled':
            starFillPercent(entry) == 100 && rating != null,
          'star-rating--unfilled': rating == null
        }"
        :percentageFill="starFillPercent(entry)"
        v-for="entry in [1, 2, 3, 4, 5]"
        :key="entry"
        :uniqueId="`${uniqueId}${entry}`"
      />
    </div>
  </div>
</template>

<script>
import Star from "./Star"
import styles from "@/styles/settings.module.scss"

export default {
  props: ["rating", "uniqueId", "colour"],

  data: () => ({
    styles
  }),

  components: {
    Star
  },
  methods: {
    starFillPercent(starPosition) {
      if (this.rating == null) {
        return 0
      } else if (this.rating == 5) {
        return 100
      } else if (starPosition <= Math.trunc(this.rating)) {
        return 100
      } else if (starPosition > Math.trunc(this.rating) + 1) {
        return 0
      } else {
        return (this.rating % 1) * 100
      }
    }
  },
  computed: {
    colourVar() {
      return {
        "--star-colour": styles["COLOUR_" + this.colour]
      }
    }
  }
}
</script>

<style lang="scss">
.star-rating {
  display: inline-block;
  vertical-align: text-bottom;
  height: 100%;

  &__row {
    height: 100%;
  }

  svg {
    height: 100%;
    width: auto;

    // @include media-breakpoint-up(md) {
    //   height: 16px;
    //   width: 16px;
    // }

    &:not(:last-child) {
      margin-right: 3px;
    }

    stop:nth-child(1) {
      stop-color: var(--star-colour);
    }
    stop:nth-child(2) {
      stop-color: var(--star-colour);
    }
    stop:nth-child(3) {
      stop-color: transparent;
    }
    stop:nth-child(4) {
      stop-color: transparent;
    }
  }

  svg.star-rating--filled {
    stop:nth-child(-n + 4) {
      stop-color: var(--star-colour);
    }
  }

  svg.star-rating--unfilled {
    stop:nth-child(-n + 4) {
      stop-color: var(--star-colour);
    }

    path {
      stroke: getcolour(bleach_black);
    }
  }
}
</style>
